import Link from "next/link";
import { cn } from "@punchup/utils/cn";

export default function SinglePaymentPolicyFooter({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mt-2 text-sm w-full max-w-md text-secondary-blue",
        className
      )}
    >
      By purchasing this content you agree to Punchup&apos;s{" "}
      <Link
        href="/tos"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Privacy Policy
      </Link>
      .
    </div>
  );
}
